import '../accountType.scss';

import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { errorTag } from 'utilities/uTagging';
import { PATH_PROFESSION } from 'constants/uTagConstants/paths';
import { ERROR_CASO_EMPLEADO } from 'constants/analyticsErrors';
import optionsActions from 'actions/optionsActions';
import accountTypeActions from 'actions/accountTypeActions';
import { DefaultQuestions } from './DefaultQuestions/DefaultQuestions';
import { ReducedQuestions } from './ReducedQuestions/ReducedQuestions';
import { goToErrorsView } from 'actions/errorViewNavigation';
import { getIsAuthorized } from 'utilities/jointHolders/holderTypes';

const EmployedComponent = ({
    accountTypeActions,
    commonList,
    disabled,
    formActions,
    options,
    shouldRenderTgssQuestion,
    userProfile,
    userProfileForm,
    ...props
}) => {
    const [showCompanyNameWarning, setShowCompanyNameWarning] = useState(false);

    const { accessToken, isJointHolder, jointHolderType } = userProfile;

    const onHandleSave = (name, value) => {
        const data = { [name]: value };

        accountTypeActions.saveEmployedInformation(data, accessToken, (saved, error) => {
            if (!saved) {
                errorTag(error.body, PATH_PROFESSION, ERROR_CASO_EMPLEADO, error.statusCode);
                goToErrorsView({ errorCode: error.statusCode, errorMessage: ERROR_CASO_EMPLEADO });
            }
        });
    };

    return isJointHolder && getIsAuthorized(jointHolderType) ? (
        <ReducedQuestions
            disabled={disabled}
            formActions={formActions}
            onHandleSave={onHandleSave}
            shouldRenderTgssQuestion={shouldRenderTgssQuestion}
            showCompanyNameWarning={showCompanyNameWarning}
            setShowCompanyNameWarning={setShowCompanyNameWarning}
            userProfile={userProfile}
            userProfileForm={userProfileForm}
        />
    ) : (
        <DefaultQuestions
            commonList={commonList}
            disabled={disabled}
            formActions={formActions}
            onHandleSave={onHandleSave}
            shouldRenderTgssQuestion={shouldRenderTgssQuestion}
            showCompanyNameWarning={showCompanyNameWarning}
            setShowCompanyNameWarning={setShowCompanyNameWarning}
            userProfile={userProfile}
            userProfileForm={userProfileForm}
            {...props}
        />
    );
};

const mapStateToProps = state => ({
    extraData: state.extraData,
    focus: state.focus,
    options: state.options,
});

const mapDispatchToProps = dispatch => ({
    accountTypeActions: bindActionCreators(accountTypeActions, dispatch),
    optionsActions: bindActionCreators(optionsActions, dispatch),
    goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
});

export const Employed = connect(mapStateToProps, mapDispatchToProps)(EmployedComponent);
